/* import __COLOCATED_TEMPLATE__ from './headline.hbs'; */
import Component from '@ember/component';
import { computed } from '@ember/object';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'h2',
  classNames: ['media-block__headline'],
  classNameBindings: ['rankClass'],
  attributeBindings: ['data-test-media-block-headline'],
  'data-test-media-block-headline': computed('rank', function () {
    if (this.rank) {
      return this.rank;
    } else {
      return true;
    }
  }),
  rankClass: computed('rank', function () {
    if (this.rank) {
      return `media-block__headline--${this.rank}`;
    } else {
      return '';
    }
  })
});